import { createFilterOptions } from '@mui/material/Autocomplete';
import { FilterOptionsState } from '@mui/material/useAutocomplete';
import { AutoCompleteOption } from 'components/common/autoComplete';

export default function useMuiAutoCompleteCreatable() {
  const filter = createFilterOptions<AutoCompleteOption>();

  const filterOptions = (
    options: AutoCompleteOption[],
    params: FilterOptionsState<AutoCompleteOption>,
    selected?: AutoCompleteOption[],
  ): AutoCompleteOption[] => {
    const filtered = filter(options, params);
    const { inputValue } = params;
    const inputValueRegex = new RegExp(inputValue.trim(), 'i');
    const isOptionExist = selected?.some((o) => inputValueRegex.test(o.label));
    if (isOptionExist) {
      return filtered;
    }
    if (inputValue?.length > 2 && !filtered.length) {
      filtered.push({
        label: inputValue,
        value: inputValue,
      });
    }
    return filtered;
  };

  return filterOptions;
}
